export class PatrimonioActividad {
    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                header: 'Código',
            },
            actividad_economica: {
                value: null,
                export: false,
                header: 'Objeto Social (Actividad principal):',
                required: 'La actividad económica es requerida'
            },
            sector_economico: {
                value: '',
                export: false,
                header: 'Sector Económico:',
                max: 200,
                required: 'El sector económico es requerido'
            },
            ingreso_promedio_mensual: {
                value: null,
                export: false,
                header: 'Ingreso Promedio Mensual ($):',
                required: 'El ingreso mensual es requerido'
            }
        }
    }
}